@if (isVisible()) {
  <div class="token-expiry-overlay">
    <div class="token-expiry-card" [class.token-expiry-card--critical]="secondsRemaining() <= 10">
      <div class="token-expiry-header">
        <i class="fa fa-clock-o token-expiry-icon"></i>
        <h3 class="token-expiry-title">{{ 'TOKEN_REFRESH.warning_title' | translate }}</h3>
      </div>

      <div class="token-expiry-body">
        <p class="token-expiry-message">
          {{ 'TOKEN_REFRESH.warning_text' | translate: { seconds: secondsRemaining() } }}
        </p>

        <div class="token-expiry-progress">
          <div class="token-expiry-progress-bar" [style.width.%]="progressPercentage()"></div>
        </div>

        <div class="token-expiry-countdown">
          <span class="token-expiry-number">{{ secondsRemaining() }}</span>
          <span class="token-expiry-unit">sec</span>
        </div>
      </div>

      <div class="token-expiry-actions">
        <button type="button" class="c-button c-button--primary" (click)="onExtendSession()" [disabled]="isExtending()">
          <i class="fa" [ngClass]="isExtending() ? 'fa-spinner fa-spin' : 'fa-refresh'"></i>
          {{ (isExtending() ? 'TOKEN_REFRESH.extending' : 'TOKEN_REFRESH.extend') | translate }}
        </button>
        <button type="button" class="c-button c-button--secondary" (click)="onLogout()" [disabled]="isExtending()">
          <i class="fa fa-sign-out"></i>
          {{ 'TOKEN_REFRESH.logout' | translate }}
        </button>
      </div>
    </div>
  </div>
}
